import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import Panel from "../../../components/shared/Panel";
import { Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
// import DashboardLimits from "./partials/DashboardLimits";
// import DashboardCaseAcceptance from "./partials/DashboardCaseAcceptance";
// import DashboardTreatmentPlansNew from "./partials/DashboardTreatmentPlansNew";
// import DashboardMonthlyStacked from "./partials/DashboardMonthlyStacked";
// import DashboardServices from "./partials/DashboardServices";
import useThemeColors from "../../../hooks/useThemeColors";
// import DashboardMoreStats from "./partials/DashboardMoreStats";
// import DashboardCaseAcceptanceAlt from "./partials/DashboardCaseAcceptanceAlt";

const OnboardingPage = ({ tenant }) => {
  // GENERAL
  const { t } = useTranslation();

  const { whiteMode, backgroundLightMode } = useThemeColors();

  // STATE

  // REDUX

  // console.log("Dashboard component rendered. userInfo:", userInfo);

  // HANDLERS

  // USEEFFECT
  useEffect(() => {
    // always scroll to top on open
    window.scrollTo(0, 0);
  }, []);

  // LOGS

  return (
    <>
      {/* HELMET  */}
      <Helmet>
        <title>{t("pageTitle.onboarding")}</title>
        <meta name="description" content={t("pageDescription.onboarding")} />
      </Helmet>

      {/* SIDEPANELS  */}

      {/* MAIN  */}
      <Panel.Wrapper>
        <Panel.Container>
          <Panel.Body>
            <Flex
              w="100%"
              p="0 0rem 1rem"
              direction="column"
              bg={backgroundLightMode}
              gap="1rem"
            ></Flex>
          </Panel.Body>
        </Panel.Container>
      </Panel.Wrapper>
    </>
  );
};

export default OnboardingPage;
